import { FETCH_PROMOTIONS_FAILURE, FETCH_PROMOTIONS_REQUEST, FETCH_PROMOTIONS_SUCCESS } from '../actions/promotions';

interface PromotionState {
  loading: boolean;
  promotions: Array<App.RatePlanPromotion>;
  total: number;
  error: string | null;
}

const initialState: PromotionState = {
  loading: false,
  promotions: [],
  total: 0,
  error: null,
};

export default function promotionsReducer(state = initialState, action): PromotionState {
  switch (action.type) {
    case FETCH_PROMOTIONS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_PROMOTIONS_SUCCESS:
      return {
        ...state,
        loading: false,
        promotions: action.payload.promotions,
        total: action.payload.total,
      };
    case FETCH_PROMOTIONS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
}
